// Header Live Search functionality
function headerLiveSearch() {
    return {
        searchQuery: '',
        showResults: false,
        loading: false,
        hasResults: false,
        products: [],
        collections: [],
        pages: [],
        articles: [],
        cachedResults: {},

        get viewAllUrl() {
            return `/search?q=${encodeURIComponent(this.searchQuery.trim())}`;
        },

        init() {
            console.log('Header Live Search initialized');
        },

        async performSearch() {
            const query = this.searchQuery.trim();

            // Don't search if query is too short
            if (query.length < 2) {
                this.showResults = false;
                this.hasResults = false;
                return;
            }

            // Check cache first
            if (this.cachedResults[query]) {
                console.log('Using cached results for:', query);
                this.displayCachedResults(query);
                return;
            }

            this.loading = true;
            this.showResults = true;

            try {
                const encodedQuery = encodeURIComponent(query);

                // Use Shopify Predictive Search API
                // https://shopify.dev/docs/api/ajax/reference/predictive-search
                const response = await fetch(
                    `/search/suggest.json?q=${encodedQuery}&resources[type]=product,page,article&resources[limit]=10&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title,vendor,body,tag`
                );

                if (!response.ok) {
                    throw new Error('Predictive search request failed');
                }

                const data = await response.json();
                console.log('Predictive Search API results:', data);

                let products = [];
                let pages = [];
                let articles = [];

                // Extract results from API response
                if (data.resources && data.resources.results) {
                    products = data.resources.results.products || [];
                    pages = data.resources.results.pages || [];
                    articles = data.resources.results.articles || [];
                }

                console.log(`Found: ${products.length} products, ${pages.length} pages, ${articles.length} articles`);

                // Process products
                this.products = [];
                if (products.length > 0) {
                    this.products = products.slice(0, 6).map(product => {
                        console.log('Product data:', product);

                        // Fix image URL - the API returns an object, we need the URL string
                        let imageUrl = '';
                        if (product.featured_image) {
                            imageUrl = typeof product.featured_image === 'string'
                                ? product.featured_image
                                : product.featured_image.url;
                        } else if (product.image) {
                            imageUrl = typeof product.image === 'string'
                                ? product.image
                                : product.image.url;
                        }

                        // Get second image if available
                        let secondImageUrl = '';
                        if (product.images && product.images.length > 1) {
                            const secondImg = product.images[1];
                            secondImageUrl = typeof secondImg === 'string' ? secondImg : (secondImg.url || secondImg);
                        }

                        // Check for badges
                        const tags = product.tags || [];
                        let badge = '';
                        if (tags.includes('Bestseller')) {
                            badge = 'Bestseller';
                        } else if (tags.includes('Neu')) {
                            badge = 'Jetzt neu';
                        } else if (tags.includes('Set')) {
                            badge = 'Set';
                        } else if (tags.includes('Empfehlung')) {
                            badge = 'Empfehlung';
                        }

                        // Split title by comma
                        const titleParts = product.title.split(',');
                        const title1 = titleParts[0] ? titleParts[0].trim().substring(0, 20) : '';
                        const title2 = titleParts[1] ? titleParts[1].trim().substring(0, 20) : '';

                        // Format price - check if already formatted or in cents
                        let formattedPrice = product.price_formatted || product.price;
                        let formattedComparePrice = product.compare_at_price_formatted || product.compare_at_price;

                        // If price is a number and looks like cents (> 100), convert
                        if (typeof formattedPrice === 'number' && formattedPrice > 100) {
                            formattedPrice = this.formatPrice(formattedPrice);
                        }
                        if (typeof formattedComparePrice === 'number' && formattedComparePrice > 100) {
                            formattedComparePrice = this.formatPrice(formattedComparePrice);
                        }

                        // Check if product has varying prices
                        let priceVaries = false;

                        if (product.price_varies !== undefined) {
                            priceVaries = product.price_varies;
                        } else if (product.price_min !== undefined && product.price_max !== undefined) {
                            priceVaries = product.price_min !== product.price_max;
                        } else if (product.variants && product.variants.length > 1) {
                            // Check if variants have different prices
                            const prices = product.variants.map(v => v.price);
                            const uniquePrices = [...new Set(prices)];
                            priceVaries = uniquePrices.length > 1;
                        }

                        // Add "ab " prefix if prices vary
                        let displayPrice = formattedPrice;
                        if (priceVaries && formattedPrice) {
                            displayPrice = `ab ${formattedPrice}`;
                        }

                        return {
                            id: product.id,
                            title: product.title,
                            title1: title1,
                            title2: title2,
                            url: product.url,
                            price: displayPrice,
                            price_varies: priceVaries,
                            compare_at_price: product.compare_at_price ? formattedComparePrice : null,
                            featured_image: imageUrl,
                            second_image: secondImageUrl,
                            handle: product.handle,
                            available: product.available !== false,
                            badge: badge,
                            tags: tags
                        };
                    });
                }

                // Process pages
                this.pages = [];
                if (pages.length > 0) {
                    this.pages = pages.slice(0, 4).map(page => ({
                        id: page.id,
                        title: page.title,
                        url: page.url
                    }));
                }

                // Process articles
                this.articles = [];
                if (articles.length > 0) {
                    this.articles = articles.slice(0, 4).map(article => ({
                        id: article.id,
                        title: article.title,
                        url: article.url,
                        summary: article.summary_html || ''
                    }));
                }

                this.hasResults = this.products.length > 0 || this.pages.length > 0 || this.articles.length > 0;

                // Cache results
                this.cachedResults[query] = {
                    products: this.products,
                    pages: this.pages,
                    articles: this.articles,
                    hasResults: this.hasResults
                };

                this.loading = false;

            } catch (error) {
                console.error('Search error:', error);
                this.loading = false;
                this.hasResults = false;
            }
        },

        displayCachedResults(query) {
            const cached = this.cachedResults[query];
            this.products = cached.products;
            this.pages = cached.pages || [];
            this.articles = cached.articles || [];
            this.hasResults = cached.hasResults;
            this.showResults = true;
            this.loading = false;
        },

        formatPrice(priceInCents) {
            const price = priceInCents / 100;
            return new Intl.NumberFormat('de-DE', {
                style: 'currency',
                currency: 'EUR'
            }).format(price);
        },

        onFocus() {
            if (this.searchQuery.trim().length >= 2) {
                this.showResults = true;
            }
        },

        closeResults() {
            // Don't close if clicking inside the search area
            setTimeout(() => {
                this.showResults = false;
            }, 200);
        },

        submitSearch() {
            const query = this.searchQuery.trim();
            if (query.length > 0) {
                window.location.href = `/search?q=${encodeURIComponent(query)}`;
            }
        }
    };
}

// Make it available globally
window.headerLiveSearch = headerLiveSearch;
